import admin from "./admin";
import Chome from "./Chome"; // 园区后台首页
import Home from '../p_park/views/Home.vue'; // 园区平台首页
import Login from '../views/Login.vue'; // 园区平台登录页
import Logout from '../views/Logout.vue'; // 退出登录
import Park from '../views/Park.vue'; // 选择园区

let route = [
    {
        path: '/',
        name: 'login',
        component: Login
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/park',
        name: 'park',
        component: Park
    }
]
route = route.concat(admin);
route = route.concat(Chome);

export default route;